/** Something on the platform that needs an admin to act, with where to act. */
export type AttentionItem =
  | { kind: "channels"; count: number }
  | { kind: "metaAds"; tokenStatus: "expired" | "revoked" }
  | { kind: "productFeeds"; count: number }
  | { kind: "lowBalance" }
  | { kind: "featureLimits"; count: number };

/**
 * Each signal is `undefined` until its data has loaded, or when it does not
 * apply to the org (no subscription, integration not enabled); an undefined
 * signal adds no item.
 */
export interface AttentionSignals {
  channelsNeedingAttention?: number | undefined;
  metaAdsTokenStatus?: string | undefined;
  failedProductFeeds?: number | undefined;
  lowBalance?: boolean | undefined;
  featureLimitsNearCap?: number | undefined;
}

/**
 * The items to show, ordered so that what stops messages from going out
 * (channels, then the Meta Ads token) comes before data and billing items.
 */
export const buildAttentionItems = (
  signals: AttentionSignals,
): Array<AttentionItem> => {
  const items: Array<AttentionItem> = [];
  if (signals.channelsNeedingAttention) {
    items.push({ kind: "channels", count: signals.channelsNeedingAttention });
  }
  if (
    signals.metaAdsTokenStatus === "expired" ||
    signals.metaAdsTokenStatus === "revoked"
  ) {
    items.push({ kind: "metaAds", tokenStatus: signals.metaAdsTokenStatus });
  }
  if (signals.failedProductFeeds) {
    items.push({ kind: "productFeeds", count: signals.failedProductFeeds });
  }
  if (signals.lowBalance) {
    items.push({ kind: "lowBalance" });
  }
  if (signals.featureLimitsNearCap) {
    items.push({ kind: "featureLimits", count: signals.featureLimitsNearCap });
  }
  return items;
};
